export const ENGLISH_LANGUAGE_CODE = 'en';
export const SPANISH_LANUGAGE_CODE = 'es';
